import * as React from "react";
import Box from "@mui/material/Box";
import { Navigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";

import ListItemButton from "@mui/material/ListItemButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import AlignVerticalCenterTwoToneIcon from "@mui/icons-material/AlignVerticalCenterTwoTone";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CheckroomTwoToneIcon from "@mui/icons-material/CheckroomTwoTone";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";

import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import logo from "../../assets/images/logoDealler.png";
import OPTIONS from "../../constant/Option";
import { useSelector } from "react-redux";
import { isNull } from "util";
import { current } from "@reduxjs/toolkit";

const DrawerBox = (props) => {
  console.log("your props", props);

  const [open, setOpen] = React.useState(false);
  const [productOpen, setProductOpen] = React.useState(false);
  const [orderOpen, setOrderOpen] = React.useState(false);
  const [invoiceOpen, setInvoiceOpen] = React.useState(false);
  const [paymentOpen, setPaymentOpen] = React.useState(false);
  const [depostOpen, setDepositOpen] = React.useState(false);
  const [visitOpen, setVisitOpen] = React.useState(false);
  const [paymentCommitment, setPaymentCommitment] = React.useState(false);
  const currentUser = useSelector((state) => state.currentUser);
  const handleClick = () => {
    setOpen(!open);
  };

  const navigate = useNavigate();

  const handleClickRoute = (e) => {
    navigate("/user");
  };
  return (
    <div>
      <Box sx={{ width: "100%", minWidth: "180px" }} role="presentation">
        <img
          className="d-lg-none"
          src={logo}
          alt="logo"
          style={{ height: "68px", marginRight: "15px" }}
        />
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {OPTIONS.usersRoles
            .onlySubAdminAccess()
            .includes(currentUser.role) ? (
            <>
              <ListItemButton
                color="primary"
                sx={{ color: "green", fontWeight: 600, fontFamily: "Raleway" }}
                onClick={handleClick}
              >
                <ListItemIcon>
                  <PeopleAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  primary="User"
                  sx={{ fontFamily: "Raleway" }}
                  primaryTypographyProps={{ fontWeight: "bold" }}
                />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      navigate("/dashboard/user");
                    }}
                  >
                    <ListItemIcon>
                      <AlignVerticalCenterTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary="List" />
                  </ListItemButton>
                </List>

                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => {
                    navigate("/dashboard/user/create");
                  }}
                >
                  <ListItemIcon>
                    <AlignVerticalCenterTwoToneIcon />
                  </ListItemIcon>
                  <ListItemText primary="Create" />
                </ListItemButton>
              </Collapse>
            </>
          ) : null}

          {OPTIONS.usersRoles
            .onlyEmployeeAccess()
            .includes(currentUser.role) ? (
            <>
              <ListItemButton
                color="primary"
                sx={{ color: "green", fontWeight: 600, fontFamily: "Raleway" }}
                onClick={handleClick}
              >
                <ListItemIcon>
                  <PeopleAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Requirement"
                  sx={{ fontFamily: "Raleway" }}
                  primaryTypographyProps={{ fontWeight: "bold" }}
                />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      navigate("/dashboard/requirement");
                    }}
                  >
                    <ListItemIcon>
                      <AlignVerticalCenterTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary="List" />
                  </ListItemButton>
                </List>

               {
                OPTIONS.usersRoles.onlySubAdminAccess().includes(currentUser.role)?(<>
                 <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => {
                    navigate("/dashboard/requirement/create");
                  }}
                >
                  <ListItemIcon>
                    <AlignVerticalCenterTwoToneIcon />
                  </ListItemIcon>
                  <ListItemText primary="Create" />
                </ListItemButton>
                </>):null
               }
              </Collapse>
            </>
          ) : null}

        </List>
      </Box>
    </div>
  );
};

export default DrawerBox;
